export default __webpack_public_path__ + "static/media/palaceofyunrau.0ec5b77e.jpg";